export default {
  Blue: '#331CBF',
  DarkenGray: '#45475D',
  White: '#FBFCFF',
  DarkGray: '#A9AAB6',
  Gray: '#C2C4D9',
};
